import { providersInvertLogo } from './game';
import { getNetworkSpeed, NetworkSpeed } from './getNetworkSpeed';

export function getProviderIcon(
  provider: string,
  mode: 'color' | 'white',
  size: 'small' | 'large',
  invert?: boolean
) {
  const template = `${window.appConfig.CDN_URL}/logos/{size}/{mode}/{provider}.svg`;

  if (!template) return '';

  const modeV = () => {
    if (providersInvertLogo.includes(provider) && invert) {
      return mode === 'color' ? 'white' : 'color';
    }

    return mode;
  };

  return template
    .replace('{size}', size === 'small' ? 'providers_small' : 'providers')
    .replace('{mode}', modeV)
    .replace('{provider}', encodeURIComponent(provider));
}

export const createUrl = (template: string) => {
  return (icon: string) => {
    if (!template) return '';
    return template.replace('{}', icon);
  };
};

export const getLocaleFlagIcon = createUrl(
  `${window.appConfig.CDN_URL}/flags/rectangular/{}.svg`
);
export const getCountryFlagIcon = createUrl(
  'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/{}.svg'
);

export const getGameCover = (icon: string) => {
  const networkSpeed = getNetworkSpeed();
  const iconSize = networkSpeed === NetworkSpeed.SLOW ? 's4' : 's3';

  return createUrl(`${window.appConfig.CDN_URL}/i/${iconSize}/{}.webp`)(icon);
};

export const getPaymentIcon = createUrl(
  `${window.appConfig.CDN_URL}/logos/payments/white/{}.svg`
);
